import { render, staticRenderFns } from "./chat_query_by_event.vue?vue&type=template&id=538c2d99&scoped=true"
import script from "./chat_query_by_event.vue?vue&type=script&lang=js"
export * from "./chat_query_by_event.vue?vue&type=script&lang=js"
import style0 from "./chat_query_by_event.vue?vue&type=style&index=0&id=538c2d99&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538c2d99",
  null
  
)

export default component.exports